import React, { useState } from 'react'
import {AiFillDelete} from 'react-icons/ai'
import { Link } from 'react-router-dom'
import BreadCrum from '../components/BreadCrum'
import Container from '../components/Container'
import Meta from '../components/Meta'
import watch from '../images/watch.jpg'
const Cart = () => {

    let [count, setCount] = useState(0);

    const handleIncrease = () =>{
        setCount(count+1)
    }
    const handleDecrease = () =>{
        if(count >0){
            setCount(count-1)
        }
        
    }
    

  return (
    <>
        <Meta title="cart" />
        <BreadCrum title="cart" />
        <Container class1="cart-wrapper home-wrapper-2 py-5">
            <div className="row">
                <div className="col-12">
                    <div className="cart-header py-3 d-flex justify-content-between align-items-center">
                        <h4 className='cart-col-1'>PRODUCT</h4>
                        <h4 className='cart-col-2'>PRICE</h4>
                        <h4 className='cart-col-3'>QUANTITY</h4>
                        <h4 className='cart-col-4'>TOTAL</h4>
                        <h4 className='cart-col-5'>ACTION</h4>
                    </div>
                    <div className="cart-data mb-2 py-3 d-flex justify-content-between align-items-center">
                        <div className='cart-col-1 d-flex align-items-center gap-15'>
                            <div className="w-25">
                                <img src={watch} className="img-fluid rounded" alt="product image" />
                            </div>
                            <div className="w-75">
                                <p>lorem</p>
                                <p>Size: XL</p>
                                <p>Color: red</p>
                            </div>
                        </div>
                        <div className='cart-col-2'>
                            <h5 className="price">$100</h5>
                        </div>
                        <div className='cart-col-3 d-flex align-items-center gap-10'>
                            <button className='px-3 py-2 border-0 rounded-circle' onClick={handleIncrease}>+</button>
                            <p className='fs-7 mb-0 bg-white px-3 py-2 rounded'>{count}</p>
                            <button className='px-3 py-2 border-0 rounded-circle' onClick={handleDecrease}>-</button>
                        </div>
                        <div className='cart-col-4'>
                                <h5 className="price">$100</h5>
                        </div>
                        <div className="cart-col-5">
                            <AiFillDelete className='text-danger' />
                        </div>
                    </div>
                </div>
                <div className="col-12 py-2 mt-4">
                    <div className="d-flex justify-content-between align-items-baseline">
                    <div>
                            <Link to="/store" className='button'>Continue Shopping</Link>
                    </div>
                    <div className='d-flex flex-column align-items-end'>
                        <h4>SubTotal: $100</h4>
                        <p>Tax and shipping calculated at checkOut</p>
                        <Link to="/checkout" className='button'>CheckOut</Link>
                    </div>
                    </div>
                </div>
            </div>
        </Container>
    </>
  )
}

export default Cart